// ── Reading progress bar ──
window.addEventListener('scroll', () => {
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrolled = (window.scrollY / docHeight) * 100;
  const bar = document.getElementById('progressBar');
  if (bar) bar.style.width = scrolled + '%';
});

// ── Scroll reveal (IntersectionObserver) ──
const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(el => observer.observe(el));

// ── Stat counter animation ──
const statNumbers = document.querySelectorAll('.stat-number[data-count]');
if (statNumbers.length) {
  const statObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.dataset.count);
        let current = 0;
        const duration = 1200;
        const step = target / (duration / 16);
        const counter = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(counter);
          }
          el.textContent = Math.round(current) + '%';
        }, 16);
        statObserver.unobserve(el);
      }
    });
  }, { threshold: 0.5 });
  statNumbers.forEach(el => statObserver.observe(el));
}

// ── FAQ toggle ──
function toggleFaq(trigger) {
  const item = trigger.parentElement;
  const panel = item.querySelector('.faq-panel');
  const inner = panel.querySelector('.faq-panel-inner');

  if (item.classList.contains('open')) {
    item.classList.remove('open');
    panel.style.maxHeight = '0';
  } else {
    document.querySelectorAll('.faq-item.open').forEach(openItem => {
      openItem.classList.remove('open');
      openItem.querySelector('.faq-panel').style.maxHeight = '0';
    });
    item.classList.add('open');
    panel.style.maxHeight = inner.scrollHeight + 24 + 'px';
  }
}

// ── Fabric accordion toggle ──
function toggleFabric(trigger) {
  const card = trigger.parentElement;
  const panel = card.querySelector('.fabric-panel');
  const inner = panel.querySelector('.fabric-panel-inner');

  if (card.classList.contains('open')) {
    card.classList.remove('open');
    panel.style.maxHeight = '0';
  } else {
    document.querySelectorAll('.fabric-card.open').forEach(openCard => {
      openCard.classList.remove('open');
      openCard.querySelector('.fabric-panel').style.maxHeight = '0';
    });
    card.classList.add('open');
    panel.style.maxHeight = inner.scrollHeight + 24 + 'px';
  }
}